import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "./style";

const NonApproved = () => {
  const { t } = useTranslation();
  return (
    <>
      <br />
      <br />
      <Container>
        <h3>{t("requestNonApproval")}</h3>
      </Container>
    </>
  );
};

export default NonApproved;
